'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentReference(id, number) {
  this.XW = null;
  this.XX = null;
  this.XW = id;
  this.XX = number;
}
export { $c_Lapp_data_DocumentReference as $c_Lapp_data_DocumentReference };
$p = $c_Lapp_data_DocumentReference.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentReference;
/** @constructor */
function $h_Lapp_data_DocumentReference() {
}
export { $h_Lapp_data_DocumentReference as $h_Lapp_data_DocumentReference };
$h_Lapp_data_DocumentReference.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_DocumentReference)) {
    var x = this.XW;
    var x$2 = x$0.XW;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      return (this.XX === x$0.XX);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentReference";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.XW;
  }
  if ((n === 1)) {
    return this.XX;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "number";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_DocumentReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jm)));
}
export { $isArrayOf_Lapp_data_DocumentReference as $isArrayOf_Lapp_data_DocumentReference };
var $d_Lapp_data_DocumentReference = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentReference, "app.data.DocumentReference", ({
  jm: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_DocumentReference as $d_Lapp_data_DocumentReference };
//# sourceMappingURL=app.data.-Document-Reference.js.map
